<template></template>

<script>
export default {
    name: 'inspiration',

    data() {
        return {
            isHover: false,
        };
    },

    mounted() {
        this.initEvents();
    },

    methods: {
        initEvents() {
            const slides = document.querySelectorAll('.item');

            slides.forEach((slide) => {
                slide.addEventListener('mouseenter', () => {
                    this.isHover = true;
                });
                slide.addEventListener('mouseleave', () => {
                    this.isHover = false;
                });
            });
        },
    },
};
</script>
